module.exports = __webpack_public_path__ + "img/jiagou.e28ab8b1.png";